import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addPostRegistrationColorRequest = {};
var _changePasswordRequest = {};
var _changePasswordResponse = {};
var _executeStepUpRequest = {};
var _executeStepUpResponse = {};
var _getColorsRequest = {};
var _getColorsResponse = {};
var _initiateStepUpRequest = {};
var _initiateStepUpResponse = {};
var _rawHttpResponse = { body: 'BYTES' };
var _removeColorRequest = {};
var _removeColorResponse = {};
var _sendAccountRecoveryCodeRequest = {};
var _sendAccountRecoveryCodeResponse = {};
var _setMyPasswordRequest = {};
var _setMyPasswordResponse = {};
var _setPasswordRequest = {};
var _setPasswordResponse = {};
var _setRegistrationColorRequest = {};
var _stepUpPasswordRequest = {};
var _stepUpPasswordResponse = {};
var _switchAccountRequest = {};
var _updateEmailRequest = {};
var _updateEmailResponse = {};
var _updatePasswordRequest = {};
var _updatePasswordResponse = {};
var _verifyAccountRecoveryCodeRequest = {};
var _verifyAccountRecoveryCodeResponse = {};
var _verifyStepUpTokenRequest = {};
var _verifyStepUpTokenResponse = {};
function resolveComWixpressUsersUsersAuthUrl(opts) {
    var domainToMappings = {
        'users._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/signin',
                destPath: '/login/form',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/m/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/signin/oauth',
                destPath: '/login/form/oauth',
            },
            {
                srcPath: '/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/social',
                destPath: '/social',
            },
            {
                srcPath: '/logo',
                destPath: '/logo',
            },
            {
                srcPath: '/apple-album',
                destPath: '/apple-album',
            },
            {
                srcPath: '/oneapp',
                destPath: '/oneapp',
            },
            {
                srcPath: '/videomaker',
                destPath: '/videomaker',
            },
            {
                srcPath: '/user/sendVerifyEmailOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/_api/v1/stub-users',
                destPath: '/v1/stub-users',
            },
            {
                srcPath: '/_api/v1/users',
                destPath: '/v1/users',
            },
            {
                srcPath: '/_api/v1/magic-link',
                destPath: '/v1/magic-link',
            },
            {
                srcPath: '/auth/v2/login',
                destPath: '/auth/v2/login',
            },
            {
                srcPath: '/hype',
                destPath: '/hype',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/v1/userAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/.well-known/assetlinks.json',
                destPath: '/api/.well-known/assetlinks.json',
            },
            {
                srcPath: '/hopp',
                destPath: '/hopp',
            },
            {
                srcPath: '/dayful',
                destPath: '/dayful',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
            {
                srcPath: '/codux',
                destPath: '/codux',
            },
            {
                srcPath: '/headless',
                destPath: '/headless',
            },
            {
                srcPath: '/_api/v1/account-recovery/verify-code',
                destPath: '/v1/users/account-recovery/verify-code',
            },
            {
                srcPath: '/_api/v1/account-recovery/send-code',
                destPath: '/v1/users/account-recovery/send-code',
            },
            {
                srcPath: '/nownia',
                destPath: '/nownia',
            },
        ],
        'sslusers._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'pmmusers._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
            {
                srcPath: '/wix-users/v1/users/colors',
                destPath: '/v1/users/colors',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmail',
                destPath: '/link/verifyUserEmail',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneApp',
                destPath: '/link/verifyUserEmailOneApp',
            },
            {
                srcPath: '/lp-mob/mobjohnbuildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/freesitebuilder/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneAppWeb',
                destPath: '/link/verifyUserEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/sendVerifyEmailByOneAppWeb',
                destPath: '/api/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/user/sendVerifyEmailByOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/m/sendVerifyEmailByOneAppWeb',
                destPath: '/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/mob-en/createcomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/mob-en/buildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/.well-known/assetlinks.json',
                destPath: '/api/.well-known/assetlinks.json',
            },
            {
                srcPath: '/blog/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/account-users/update-email',
                destPath: '/v1/account-users/update-email',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-html-login-webapp',
                destPath: '',
            },
            {
                srcPath: '/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'support._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/users-login',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/users-login',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/freesitebuilder/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohnbuildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmail',
                destPath: '/link/verifyUserEmail',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneApp',
                destPath: '/link/verifyUserEmailOneApp',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneAppWeb',
                destPath: '/link/verifyUserEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/m/sendVerifyEmailByOneAppWeb',
                destPath: '/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/sendVerifyEmailByOneAppWeb',
                destPath: '/api/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/user/sendVerifyEmailByOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wix-users/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/wix-users/auth/setLanguage',
                destPath: '/auth/setLanguage',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
            {
                srcPath: '/wix-users/v1/users/initiate-authentication',
                destPath: '/v1/users/initiate-authentication',
            },
            {
                srcPath: '/wix-users/v1/users/execute-authentication',
                destPath: '/v1/users/execute-authentication',
            },
            {
                srcPath: '/wix-users/v1/users/set-my-password',
                destPath: '/v1/users/set-my-password',
            },
            {
                srcPath: '/wix-users/v1/users/twofa-settings',
                destPath: '/v1/users/twofa-settings',
            },
            {
                srcPath: '/wix-users/v1/users/colors',
                destPath: '/v1/users/colors',
            },
        ],
        'api.wixpress.com': [
            {
                srcPath: '/wix-html-login-webapp',
                destPath: '',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
        ],
        'online.codux.com': [
            {
                srcPath: '/signin',
                destPath: '/login/form',
            },
            {
                srcPath: '/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/v1/userAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/social',
                destPath: '/social',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/auth/forgotPassword',
                destPath: '/auth/forgotPassword',
            },
        ],
        'users.nownia.com': [
            {
                srcPath: '/signin',
                destPath: '/login/form',
            },
            {
                srcPath: '/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/social',
                destPath: '/social',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/v1/userAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/auth/forgotPassword',
                destPath: '/auth/forgotPassword',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressUsersAccountUsersServiceUrl(opts) {
    var domainToMappings = {
        'users._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/signin',
                destPath: '/login/form',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/m/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/signin/oauth',
                destPath: '/login/form/oauth',
            },
            {
                srcPath: '/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/social',
                destPath: '/social',
            },
            {
                srcPath: '/logo',
                destPath: '/logo',
            },
            {
                srcPath: '/apple-album',
                destPath: '/apple-album',
            },
            {
                srcPath: '/oneapp',
                destPath: '/oneapp',
            },
            {
                srcPath: '/videomaker',
                destPath: '/videomaker',
            },
            {
                srcPath: '/user/sendVerifyEmailOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/_api/v1/stub-users',
                destPath: '/v1/stub-users',
            },
            {
                srcPath: '/_api/v1/users',
                destPath: '/v1/users',
            },
            {
                srcPath: '/_api/v1/magic-link',
                destPath: '/v1/magic-link',
            },
            {
                srcPath: '/auth/v2/login',
                destPath: '/auth/v2/login',
            },
            {
                srcPath: '/hype',
                destPath: '/hype',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/v1/userAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/.well-known/assetlinks.json',
                destPath: '/api/.well-known/assetlinks.json',
            },
            {
                srcPath: '/hopp',
                destPath: '/hopp',
            },
            {
                srcPath: '/dayful',
                destPath: '/dayful',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
            {
                srcPath: '/codux',
                destPath: '/codux',
            },
            {
                srcPath: '/headless',
                destPath: '/headless',
            },
            {
                srcPath: '/_api/v1/account-recovery/verify-code',
                destPath: '/v1/users/account-recovery/verify-code',
            },
            {
                srcPath: '/_api/v1/account-recovery/send-code',
                destPath: '/v1/users/account-recovery/send-code',
            },
        ],
        'sslusers._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'pmmusers._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
            {
                srcPath: '/wix-users/v1/users/colors',
                destPath: '/v1/users/colors',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmail',
                destPath: '/link/verifyUserEmail',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneApp',
                destPath: '/link/verifyUserEmailOneApp',
            },
            {
                srcPath: '/lp-mob/mobjohnbuildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/freesitebuilder/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneAppWeb',
                destPath: '/link/verifyUserEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/sendVerifyEmailByOneAppWeb',
                destPath: '/api/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/user/sendVerifyEmailByOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/m/sendVerifyEmailByOneAppWeb',
                destPath: '/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/mob-en/createcomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/mob-en/buildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/.well-known/assetlinks.json',
                destPath: '/api/.well-known/assetlinks.json',
            },
            {
                srcPath: '/blog/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/account-users/update-email',
                destPath: '/v1/account-users/update-email',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-html-login-webapp',
                destPath: '',
            },
            {
                srcPath: '/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'support._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/users-login',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/users-login',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/freesitebuilder/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohnbuildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmail',
                destPath: '/link/verifyUserEmail',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneApp',
                destPath: '/link/verifyUserEmailOneApp',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneAppWeb',
                destPath: '/link/verifyUserEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/m/sendVerifyEmailByOneAppWeb',
                destPath: '/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/sendVerifyEmailByOneAppWeb',
                destPath: '/api/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/user/sendVerifyEmailByOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wix-users/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/wix-users/auth/setLanguage',
                destPath: '/auth/setLanguage',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
            {
                srcPath: '/wix-users/v1/users/initiate-authentication',
                destPath: '/v1/users/initiate-authentication',
            },
            {
                srcPath: '/wix-users/v1/users/execute-authentication',
                destPath: '/v1/users/execute-authentication',
            },
            {
                srcPath: '/wix-users/v1/users/set-my-password',
                destPath: '/v1/users/set-my-password',
            },
            {
                srcPath: '/wix-users/v1/users/twofa-settings',
                destPath: '/v1/users/twofa-settings',
            },
            {
                srcPath: '/wix-users/v1/users/colors',
                destPath: '/v1/users/colors',
            },
        ],
        'api.wixpress.com': [
            {
                srcPath: '/wix-html-login-webapp',
                destPath: '',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
        ],
        'online.codux.com': [
            {
                srcPath: '/signin',
                destPath: '/login/form',
            },
            {
                srcPath: '/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/v1/userAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/social',
                destPath: '/social',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/auth/forgotPassword',
                destPath: '/auth/forgotPassword',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressUsersAccountRecoveryUrl(opts) {
    var domainToMappings = {
        'users._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/signin',
                destPath: '/login/form',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/m/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/signin/oauth',
                destPath: '/login/form/oauth',
            },
            {
                srcPath: '/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/social',
                destPath: '/social',
            },
            {
                srcPath: '/logo',
                destPath: '/logo',
            },
            {
                srcPath: '/apple-album',
                destPath: '/apple-album',
            },
            {
                srcPath: '/oneapp',
                destPath: '/oneapp',
            },
            {
                srcPath: '/videomaker',
                destPath: '/videomaker',
            },
            {
                srcPath: '/user/sendVerifyEmailOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/_api/v1/stub-users',
                destPath: '/v1/stub-users',
            },
            {
                srcPath: '/_api/v1/users',
                destPath: '/v1/users',
            },
            {
                srcPath: '/_api/v1/magic-link',
                destPath: '/v1/magic-link',
            },
            {
                srcPath: '/auth/v2/login',
                destPath: '/auth/v2/login',
            },
            {
                srcPath: '/hype',
                destPath: '/hype',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/v1/userAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/.well-known/assetlinks.json',
                destPath: '/api/.well-known/assetlinks.json',
            },
            {
                srcPath: '/hopp',
                destPath: '/hopp',
            },
            {
                srcPath: '/dayful',
                destPath: '/dayful',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
            {
                srcPath: '/codux',
                destPath: '/codux',
            },
            {
                srcPath: '/headless',
                destPath: '/headless',
            },
            {
                srcPath: '/_api/v1/account-recovery/verify-code',
                destPath: '/v1/users/account-recovery/verify-code',
            },
            {
                srcPath: '/_api/v1/account-recovery/send-code',
                destPath: '/v1/users/account-recovery/send-code',
            },
        ],
        'sslusers._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'pmmusers._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
            {
                srcPath: '/wix-users/v1/users/colors',
                destPath: '/v1/users/colors',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmail',
                destPath: '/link/verifyUserEmail',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneApp',
                destPath: '/link/verifyUserEmailOneApp',
            },
            {
                srcPath: '/lp-mob/mobjohnbuildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/freesitebuilder/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneAppWeb',
                destPath: '/link/verifyUserEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/sendVerifyEmailByOneAppWeb',
                destPath: '/api/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/user/sendVerifyEmailByOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/m/sendVerifyEmailByOneAppWeb',
                destPath: '/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/mob-en/createcomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/mob-en/buildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/.well-known/assetlinks.json',
                destPath: '/api/.well-known/assetlinks.json',
            },
            {
                srcPath: '/blog/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/account-users/update-email',
                destPath: '/v1/account-users/update-email',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-html-login-webapp',
                destPath: '',
            },
            {
                srcPath: '/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'support._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/users-login',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/users-login',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/freesitebuilder/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohnbuildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmail',
                destPath: '/link/verifyUserEmail',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneApp',
                destPath: '/link/verifyUserEmailOneApp',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneAppWeb',
                destPath: '/link/verifyUserEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/m/sendVerifyEmailByOneAppWeb',
                destPath: '/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/sendVerifyEmailByOneAppWeb',
                destPath: '/api/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/user/sendVerifyEmailByOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wix-users/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/wix-users/auth/setLanguage',
                destPath: '/auth/setLanguage',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
            {
                srcPath: '/wix-users/v1/users/initiate-authentication',
                destPath: '/v1/users/initiate-authentication',
            },
            {
                srcPath: '/wix-users/v1/users/execute-authentication',
                destPath: '/v1/users/execute-authentication',
            },
            {
                srcPath: '/wix-users/v1/users/set-my-password',
                destPath: '/v1/users/set-my-password',
            },
            {
                srcPath: '/wix-users/v1/users/twofa-settings',
                destPath: '/v1/users/twofa-settings',
            },
            {
                srcPath: '/wix-users/v1/users/colors',
                destPath: '/v1/users/colors',
            },
        ],
        'api.wixpress.com': [
            {
                srcPath: '/wix-html-login-webapp',
                destPath: '',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
        ],
        'online.codux.com': [
            {
                srcPath: '/signin',
                destPath: '/login/form',
            },
            {
                srcPath: '/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/v1/userAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/social',
                destPath: '/social',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/auth/forgotPassword',
                destPath: '/auth/forgotPassword',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressUsersUserColorsServiceUrl(opts) {
    var domainToMappings = {
        'users._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/signin',
                destPath: '/login/form',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/m/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/signin/oauth',
                destPath: '/login/form/oauth',
            },
            {
                srcPath: '/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/social',
                destPath: '/social',
            },
            {
                srcPath: '/logo',
                destPath: '/logo',
            },
            {
                srcPath: '/apple-album',
                destPath: '/apple-album',
            },
            {
                srcPath: '/oneapp',
                destPath: '/oneapp',
            },
            {
                srcPath: '/videomaker',
                destPath: '/videomaker',
            },
            {
                srcPath: '/user/sendVerifyEmailOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/_api/v1/stub-users',
                destPath: '/v1/stub-users',
            },
            {
                srcPath: '/_api/v1/users',
                destPath: '/v1/users',
            },
            {
                srcPath: '/_api/v1/magic-link',
                destPath: '/v1/magic-link',
            },
            {
                srcPath: '/auth/v2/login',
                destPath: '/auth/v2/login',
            },
            {
                srcPath: '/hype',
                destPath: '/hype',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/v1/userAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/.well-known/assetlinks.json',
                destPath: '/api/.well-known/assetlinks.json',
            },
            {
                srcPath: '/hopp',
                destPath: '/hopp',
            },
            {
                srcPath: '/dayful',
                destPath: '/dayful',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
            {
                srcPath: '/codux',
                destPath: '/codux',
            },
            {
                srcPath: '/headless',
                destPath: '/headless',
            },
            {
                srcPath: '/_api/v1/account-recovery/verify-code',
                destPath: '/v1/users/account-recovery/verify-code',
            },
            {
                srcPath: '/_api/v1/account-recovery/send-code',
                destPath: '/v1/users/account-recovery/send-code',
            },
        ],
        'sslusers._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'pmmusers._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
            {
                srcPath: '/wix-users/v1/users/colors',
                destPath: '/v1/users/colors',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmail',
                destPath: '/link/verifyUserEmail',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneApp',
                destPath: '/link/verifyUserEmailOneApp',
            },
            {
                srcPath: '/lp-mob/mobjohnbuildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/freesitebuilder/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneAppWeb',
                destPath: '/link/verifyUserEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/sendVerifyEmailByOneAppWeb',
                destPath: '/api/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/user/sendVerifyEmailByOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/m/sendVerifyEmailByOneAppWeb',
                destPath: '/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/mob-en/createcomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/mob-en/buildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/.well-known/assetlinks.json',
                destPath: '/api/.well-known/assetlinks.json',
            },
            {
                srcPath: '/blog/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/account-users/update-email',
                destPath: '/v1/account-users/update-email',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-html-login-webapp',
                destPath: '',
            },
            {
                srcPath: '/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'support._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/users-login',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/users-login',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/freesitebuilder/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohnbuildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmail',
                destPath: '/link/verifyUserEmail',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneApp',
                destPath: '/link/verifyUserEmailOneApp',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneAppWeb',
                destPath: '/link/verifyUserEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/m/sendVerifyEmailByOneAppWeb',
                destPath: '/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/sendVerifyEmailByOneAppWeb',
                destPath: '/api/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/user/sendVerifyEmailByOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wix-users/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/wix-users/auth/setLanguage',
                destPath: '/auth/setLanguage',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
            {
                srcPath: '/wix-users/v1/users/initiate-authentication',
                destPath: '/v1/users/initiate-authentication',
            },
            {
                srcPath: '/wix-users/v1/users/execute-authentication',
                destPath: '/v1/users/execute-authentication',
            },
            {
                srcPath: '/wix-users/v1/users/set-my-password',
                destPath: '/v1/users/set-my-password',
            },
            {
                srcPath: '/wix-users/v1/users/twofa-settings',
                destPath: '/v1/users/twofa-settings',
            },
            {
                srcPath: '/wix-users/v1/users/colors',
                destPath: '/v1/users/colors',
            },
        ],
        'api.wixpress.com': [
            {
                srcPath: '/wix-html-login-webapp',
                destPath: '',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
        ],
        'online.codux.com': [
            {
                srcPath: '/signin',
                destPath: '/login/form',
            },
            {
                srcPath: '/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/v1/userAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/social',
                destPath: '/social',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/auth/forgotPassword',
                destPath: '/auth/forgotPassword',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Sets user registration color and returns a new session with the newly updated colors */
export function setRegistrationColor(payload) {
    var _a = serializer(_setRegistrationColorRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __setRegistrationColor(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'PUT',
            methodFqn: 'com.wixpress.users.UserColorsService.SetRegistrationColor',
            url: resolveComWixpressUsersUserColorsServiceUrl({
                protoPath: '/v1/users/colors/set-registration-color',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setRegistrationColor.fromReq = fromReq;
    __setRegistrationColor.__isAmbassador = true;
    return __setRegistrationColor;
}
/** Adds user post registration color and returns a new session with the newly updated colors */
export function addPostRegistrationColor(payload) {
    var _a = serializer(_addPostRegistrationColorRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __addPostRegistrationColor(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'PUT',
            methodFqn: 'com.wixpress.users.UserColorsService.AddPostRegistrationColor',
            url: resolveComWixpressUsersUserColorsServiceUrl({
                protoPath: '/v1/users/colors/add-post-registration-color',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addPostRegistrationColor.fromReq = fromReq;
    __addPostRegistrationColor.__isAmbassador = true;
    return __addPostRegistrationColor;
}
/** Returns user colors */
export function getColors(payload) {
    var _a = serializer(_getColorsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getColorsResponse, {}).fromJSON;
    function __getColors(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'GET',
            methodFqn: 'com.wixpress.users.UserColorsService.GetColors',
            url: resolveComWixpressUsersUserColorsServiceUrl({
                protoPath: '/v1/users/colors',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getColors.fromReq = fromReq;
    __getColors.__isAmbassador = true;
    return __getColors;
}
/** Removes user color, whether it is the Registration Color or a post registration color */
export function removeColor(payload) {
    var _a = serializer(_removeColorRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeColorResponse, {}).fromJSON;
    function __removeColor(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'DELETE',
            methodFqn: 'com.wixpress.users.UserColorsService.RemoveColor',
            url: resolveComWixpressUsersUserColorsServiceUrl({
                protoPath: '/v1/users/colors',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeColor.fromReq = fromReq;
    __removeColor.__isAmbassador = true;
    return __removeColor;
}
/** Sends account recovery code */
export function sendAccountRecoveryCode(payload) {
    var _a = serializer(_sendAccountRecoveryCodeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendAccountRecoveryCodeResponse, {}).fromJSON;
    function __sendAccountRecoveryCode(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'POST',
            methodFqn: 'com.wixpress.users.AccountRecovery.SendAccountRecoveryCode',
            url: resolveComWixpressUsersAccountRecoveryUrl({
                protoPath: '/v1/users/account-recovery/send-code',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendAccountRecoveryCode.fromReq = fromReq;
    __sendAccountRecoveryCode.__isAmbassador = true;
    return __sendAccountRecoveryCode;
}
/** Verifies account recovery code */
export function verifyAccountRecoveryCode(payload) {
    var _a = serializer(_verifyAccountRecoveryCodeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_verifyAccountRecoveryCodeResponse, {}).fromJSON;
    function __verifyAccountRecoveryCode(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'POST',
            methodFqn: 'com.wixpress.users.AccountRecovery.VerifyAccountRecoveryCode',
            url: resolveComWixpressUsersAccountRecoveryUrl({
                protoPath: '/v1/users/account-recovery/verify-code',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __verifyAccountRecoveryCode.fromReq = fromReq;
    __verifyAccountRecoveryCode.__isAmbassador = true;
    return __verifyAccountRecoveryCode;
}
/**
 * decisions so far:
 * 1. accountId will be fetched from ExternalApp.AccountData, instead of IdentityContext - that's because of Member with hasUserRole security breach
 * 2. userId will be validated to belong to the accountId from (1) - only direct relation, no transitive, sub-accounts
 * 3. in terms of authorization, the only thing that will be checked is isPermitted(permission), as well as userId->accountId relation
 * 4. do we want some BI - yes, email-to-user at the end - no.
 */
export function updatePassword(payload) {
    var _a = serializer(_updatePasswordRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePasswordResponse, {}).fromJSON;
    function __updatePassword(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'POST',
            methodFqn: 'com.wixpress.users.AccountUsersService.updatePassword',
            url: resolveComWixpressUsersAccountUsersServiceUrl({
                protoPath: '/v1/account-users/update-password',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePassword.fromReq = fromReq;
    __updatePassword.__isAmbassador = true;
    return __updatePassword;
}
/** updates user email */
export function updateEmail(payload) {
    var _a = serializer(_updateEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateEmailResponse, {}).fromJSON;
    function __updateEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'PUT',
            methodFqn: 'com.wixpress.users.AccountUsersService.updateEmail',
            url: resolveComWixpressUsersAccountUsersServiceUrl({
                protoPath: '/v1/account-users/update-email',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateEmail.fromReq = fromReq;
    __updateEmail.__isAmbassador = true;
    return __updateEmail;
}
/**
 * Initiates StepUp process
 * The userId is extracted from the session
 */
export function initiateStepUp(payload) {
    var _a = serializer(_initiateStepUpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_initiateStepUpResponse, {}).fromJSON;
    function __initiateStepUp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'POST',
            methodFqn: 'com.wixpress.users.UsersAuth.InitiateStepUp',
            url: resolveComWixpressUsersUsersAuthUrl({
                protoPath: '/v1/users/initiate-authentication',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __initiateStepUp.fromReq = fromReq;
    __initiateStepUp.__isAmbassador = true;
    return __initiateStepUp;
}
/**
 * Executes StepUp process
 * The userId is extracted from the session
 */
export function executeStepUp(payload) {
    var _a = serializer(_executeStepUpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_executeStepUpResponse, {}).fromJSON;
    function __executeStepUp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'POST',
            methodFqn: 'com.wixpress.users.UsersAuth.ExecuteStepUp',
            url: resolveComWixpressUsersUsersAuthUrl({
                protoPath: '/v1/users/execute-authentication/{verificationId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __executeStepUp.fromReq = fromReq;
    __executeStepUp.__isAmbassador = true;
    return __executeStepUp;
}
/** Step up for password */
export function stepUpPassword(payload) {
    var _a = serializer(_stepUpPasswordRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_stepUpPasswordResponse, {}).fromJSON;
    function __stepUpPassword(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'POST',
            methodFqn: 'com.wixpress.users.UsersAuth.StepUpPassword',
            url: resolveComWixpressUsersUsersAuthUrl({
                protoPath: '/v1/step-up/password/verify',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __stepUpPassword.fromReq = fromReq;
    __stepUpPassword.__isAmbassador = true;
    return __stepUpPassword;
}
/** Verify step-up tokens */
export function verifyStepUpToken(payload) {
    var _a = serializer(_verifyStepUpTokenRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_verifyStepUpTokenResponse, {}).fromJSON;
    function __verifyStepUpToken(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'POST',
            methodFqn: 'com.wixpress.users.UsersAuth.VerifyStepUpToken',
            url: resolveComWixpressUsersUsersAuthUrl({
                protoPath: '/v1/step-up/verify-token',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __verifyStepUpToken.fromReq = fromReq;
    __verifyStepUpToken.__isAmbassador = true;
    return __verifyStepUpToken;
}
/** Switches user account by returning new session of the new account and optionally redirect to a desired url */
export function switchAccount(payload) {
    var _a = serializer(_switchAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __switchAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'GET',
            methodFqn: 'com.wixpress.users.UsersAuth.SwitchAccount',
            url: resolveComWixpressUsersUsersAuthUrl({
                protoPath: '/v1/users/switch-account',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __switchAccount.fromReq = fromReq;
    __switchAccount.__isAmbassador = true;
    return __switchAccount;
}
/** Sets a new password for a User by optionally verifying the current password is the password of the User. */
export function setPassword(payload) {
    var _a = serializer(_setPasswordRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setPasswordResponse, {}).fromJSON;
    function __setPassword(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'POST',
            methodFqn: 'com.wixpress.users.UsersAuth.SetPassword',
            url: resolveComWixpressUsersUsersAuthUrl({
                protoPath: '/v1/users/set-password',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setPassword.fromReq = fromReq;
    __setPassword.__isAmbassador = true;
    return __setPassword;
}
/** Sets a new password for the logged-in User by verifying the current password is the password of the User. */
export function setMyPassword(payload) {
    var _a = serializer(_setMyPasswordRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setMyPasswordResponse, {}).fromJSON;
    function __setMyPassword(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'POST',
            methodFqn: 'com.wixpress.users.UsersAuth.SetMyPassword',
            url: resolveComWixpressUsersUsersAuthUrl({
                protoPath: '/v1/users/set-my-password',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setMyPassword.fromReq = fromReq;
    __setMyPassword.__isAmbassador = true;
    return __setMyPassword;
}
/** Changes user password with token */
export function changePassword(payload) {
    var _a = serializer(_changePasswordRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_changePasswordResponse, {}).fromJSON;
    function __changePassword(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.users.v1.user',
            method: 'POST',
            methodFqn: 'com.wixpress.users.UsersAuth.ChangePassword',
            url: resolveComWixpressUsersUsersAuthUrl({
                protoPath: '/v1/users/change-password',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __changePassword.fromReq = fromReq;
    __changePassword.__isAmbassador = true;
    return __changePassword;
}
//# sourceMappingURL=http.impl.js.map